import { getJSONfromDOM } from '@pixelcabin/ui-utils';

/**
 * Uses the API of vue-custom-element to preprocess the props which are passed
 * as string values but which need to be initialised JS objects before the component mounts.
 *
 * See https://github.com/karol-f/vue-custom-element#options
 */
export const dynamicCollectionTabsPreprocess = {
  beforeCreateVueInstance(RootComponentDefinition) {
    try {
      const instanceId =
        RootComponentDefinition.el.parentElement.dataset.instanceId;
      const initialData = getJSONfromDOM([
        `#pxl-dynamic-collection-tabs-${instanceId}`
      ]);
      const { propsData } = RootComponentDefinition;

      const { collectionLinks, defaultActiveCollection } = initialData;

      RootComponentDefinition.propsData = {
        ...propsData,
        collectionLinks,
        defaultActiveCollection
      };
    } catch (err) {
      console.warn(err);
    }

    return RootComponentDefinition;
  }
};

export const dynamicArticlesTabsPreprocess = {
  beforeCreateVueInstance(RootComponentDefinition) {
    try {
      const instanceId =
        RootComponentDefinition.el.parentElement.dataset.instanceId;
      const initialData = getJSONfromDOM([
        `#pxl-dynamic-article-tabs-${instanceId}`
      ]);
      const { propsData } = RootComponentDefinition;

      const { links, defaultArticles } = initialData;

      RootComponentDefinition.propsData = {
        ...propsData,
        links,
        defaultArticles
      };
    } catch (err) {
      console.warn(err);
    }

    return RootComponentDefinition;
  }
};
